import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import AdjustmentForm from 'components/organisms/forms/AdjustmentForm'

import { crudActionsMap } from 'utils/helpers'

const AdjustmentCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.accommodations-and-modifications')} / ${t('common.' + action)}`} />
      <PageBody>
        <AdjustmentForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default AdjustmentCrudPage
